import SuggestedProducts from "./SuggestedProducts";

export default SuggestedProducts;
